import useApi from "hooks/useApi";
import { useQuery } from "react-query";
import { handleAxiosError } from "./utils";

interface UseQueryMerchantConfigurationProps {
  readonly marketplace: string;
  readonly merchantId?: string;
}

export interface MerchantConfigurationResponse {
  readonly merchantId?: string;
  readonly email?: string;
  readonly password?: string;
}

const MERCHANT_CONFIGURATION_ENDPOINT = "/merchant-configuration";

export default function useQueryMerchantConfiguration(requestParams: UseQueryMerchantConfigurationProps) {
  const api = useApi();

  const fetchMerchantConfiguration: () => Promise<MerchantConfigurationResponse> = async () => {
    try {
      // TODO: IBA-CORE-2935 Refactor http verb to POST for this endpoint
      const { data }: { data: MerchantConfigurationResponse } = await api.get(MERCHANT_CONFIGURATION_ENDPOINT, {
        params: requestParams,
      });

      return data;
    } catch (e) {
      return handleAxiosError(e);
    }
  };

  const queryKey = ["MerchantConfiguration", requestParams];
  return useQuery<MerchantConfigurationResponse, string>(queryKey, fetchMerchantConfiguration, { enabled: false });
}
